import { FC } from "react";

const CustomToggleButton: FC<CustomToggleButtonProps> = ({
  value,
  onToggle,
  optionOne,
  optionTwo,
  className = "",
}) => {
  return (
    <div
      className={`flex rounded-3xl border border-gray-3 bg-gray-100 gap-2 p-1 ${className}`}
    >
      <button
        onClick={() => onToggle(optionOne.value)}
        className={`flex-1 px-4 py-2 text-sm font-medium text-center rounded-3xl transition-all 
          ${
            value === optionOne.value
              ? "bg-gray-7 text-white shadow"
              : "bg-transparent text-gray-700 hover:bg-gray-200"
          }`}
      >
        {optionOne.label}
      </button>
      <button
        onClick={() => onToggle(optionTwo.value)}
        className={`flex-1 px-4 py-2 text-sm font-medium text-center rounded-3xl transition-all 
          ${
            value === optionTwo.value
              ? "bg-gray-7 text-white shadow"
              : "bg-transparent text-gray-700 hover:bg-gray-200"
          }`}
      >
        {optionTwo.label}
      </button>
    </div>
  );
};

export default CustomToggleButton;

interface CustomToggleButtonProps {
  value: string; // The currently selected value
  onToggle: (value: string) => void; // Callback to handle the toggle
  optionOne: { label: string; value: string }; // First toggle option
  optionTwo: { label: string; value: string }; // Second toggle option
  className?: string; // Optional custom styles for the container
}
